import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home/index';
import { Services } from './pages/Services/index';
import { AIAutomation } from './pages/AIAutomation/index';
import { Contact } from './pages/Contact/index';
import { Support } from './pages/Support/index';
import { About } from './pages/About/index';
import { PrivacyPolicy } from './pages/PrivacyPolicy/index';
import { MobileApps } from './pages/services/MobileApps/index';
import { WebDevelopment } from './pages/services/WebDevelopment/index';
import { EmbeddedSystems } from './pages/services/EmbeddedSystems/index';
import { DatabaseSolutions } from './pages/services/DatabaseSolutions/index';
import { HighAvailability } from './pages/services/HighAvailability/index';
import { GlobalFileSystem } from './pages/services/GlobalFileSystem/index';
import { ECommerce } from './pages/services/ECommerce/index';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-1" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/services" element={<Services data-id="element-8" />} data-id="element-7" />
            <Route path="/services/mobile-apps" element={<MobileApps data-id="element-10" />} data-id="element-9" />
            <Route path="/services/web-development" element={<WebDevelopment data-id="element-12" />} data-id="element-11" />
            <Route path="/services/e-commerce" element={<ECommerce data-id="element-14" />} data-id="element-13" />
            <Route path="/services/embedded-systems" element={<EmbeddedSystems data-id="element-16" />} data-id="element-15" />
            <Route path="/services/database-solutions" element={<DatabaseSolutions data-id="element-18" />} data-id="element-17" />
            <Route path="/services/high-availability" element={<HighAvailability data-id="element-20" />} data-id="element-19" />
            <Route path="/services/global-file-system" element={<GlobalFileSystem data-id="element-22" />} data-id="element-21" />
            <Route path="/ai-automation" element={<AIAutomation data-id="element-24" />} data-id="element-23" />
            <Route path="/contact" element={<Contact data-id="element-26" />} data-id="element-25" />
            <Route path="/about" element={<About data-id="element-28" />} data-id="element-27" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-30" />} data-id="element-29" />
            <Route path="/support" element={<Support data-id="element-32" />} data-id="element-31" />
          </Routes>
        </main>
        <Footer data-id="element-33" />
      </div>
    </Router>;
}